import {useEffect, useState} from "react";


const ROIFilterTeamRow = (props) => {

    const [team, setTeam] = useState(null)
    const [colour, setColour] = useState('#0082CA')
    const [selected, setSelected] = useState(false)

    useEffect(() => {
        setTeam(props.team)
    }, [props.team]);

    useEffect(() => {
        setColour(props.colour)
    }, [props.colour])

    useEffect(() => {
        if(!team) return;
        let isSelected = false

        for (const selectedTeam of props.selected) {
            if ((selectedTeam.team_id === team.team_id) && (selectedTeam.demo === team.demo)) {
                isSelected = true
                break;
            }
        }

        setSelected(isSelected)
    }, [props.selected, team]);

    const updateSelected = (ev) => {
        if(!ev) return;
        props.update([team])
    }

    return (
        <div className="roi-filter-team-row">
            <div className={`roi-filter-selected-box ${selected ? "filled" : ""}`} onClick={updateSelected}>
                {selected ? "✓" : ""}
            </div>
            <div className="filter-colour-circle" style={{backgroundColor: colour}}/>
            <div className="filter-organisation-name regular">{team && team.team_name}</div>
        </div>
    )
}

export default ROIFilterTeamRow